import React from 'react'
import EditModal from './EditModal'

const PowerAppSolutionEditModal = ({solutionId, showModal, callback, onCloseModal, refresh, recertificationTaskId}) => {

    const onCloseSolutionModal = () => {
        if (onCloseModal)
            onCloseModal()
    }

    return (
        <EditModal 
            onCloseModal={onCloseSolutionModal} 
            isModalOpened={showModal}
            itemId={solutionId}
            callBack={callback}
            isPowerAppSolution={true}
            isEditable={true}
            refreshCallback={refresh}
            recertificationTaskId={recertificationTaskId}
        />
    )
}

export default PowerAppSolutionEditModal


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppSolutionEditModal.js